import { animate, AnimationMetadata, style } from "@angular/animations";
import { ComponentFactoryResolver, ViewContainerRef } from "@angular/core";

export class DialogConfig<D = any> {
	viewContainerRef?: ViewContainerRef;
	id?: string;
	disableClose? = false;
	hasBackdrop? = true;
	width? = "";
	height? = "";
	minWidth?: number | string;
	minHeight?: number | string;
	maxWidth?: number | string = "100vw";
	maxHeight?: number | string;
	position?: DialogPosition;
	data?: D | any | null = null;
	panelClass?: string;
	backdrop?: "transparent" | "dark" = "dark";
	backdropClass?: string;
	autoFocus? = true;
	componentFactoryResolver?: ComponentFactoryResolver;
	scrollStrategy?: "block" | "noop" = "block";
	animations?: { open: AnimationMetadata[]; close: AnimationMetadata[] } = dialogAnimations;
}

export interface DialogPosition {
	top?: string;
	bottom?: string;
	left?: string;
	right?: string;
}

const dialogAnimations = {
	open: [style({ opacity: "0" }), animate("200ms", style({ opacity: "1" }))],
	close: [animate("200ms", style({ opacity: "0" }))],
};
